export default __webpack_public_path__ + "static/media/13H.3d682f9c.webp";